import * as React from "react"
import {useEffect} from "react";
import { Grid } from "@mui/material"

import { MANAGEMENT_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import {isSystemBusy} from "@signals";
import { isEmpty, resetManagementKeywordsCrudSignals } from "./@signals";
import ManagementKeywordsCrudFilters from "./Filters";
import KeywordsTable from "./KeywordsTable";
import KeywordDrawer from "./KeywordDrawer";


export default function ManagementKeywordsCrudPage() {

    const props = {
        head: `DIP Insight | ${MANAGEMENT_ROUTES.KEYWORDS_CRUDS_TITLE}`,
        title: MANAGEMENT_ROUTES.KEYWORDS_CRUDS_TITLE,
        isEmpty: isEmpty.value,
        actions:null,
        filters: <ManagementKeywordsCrudFilters />,
        hasErrors: isSystemBusy.value
    }

    useEffect(() => {
        return () => resetManagementKeywordsCrudSignals()
    },[])

    return <PageWrapper {...props}>
        <Grid container spacing={2}>

            <Grid item xs={12}>
                <KeywordsTable />
            </Grid>

            <Grid item xs={12}>
                <KeywordDrawer />
            </Grid>

        </Grid>
    </PageWrapper>
}